module.exports = __webpack_public_path__ + "static/media/sd.7ab061d8.svg";